import React from 'react';
import ProductForm from './ProductForm';
import ProductItem from './ProductItem';
import { useSelector } from "react-redux";
import Cart from './Cart';

function Body() {
    //Hooks
    const isProductPage = useSelector((state) => state.products.isProductPage);

    //JSX
    return (
        isProductPage ? (
            <div class="productWrapper">
                <div class="productContainer" id="lws-productContainer">
                    <ProductItem />
                </div>
                <ProductForm />
            </div>

        ) : <Cart />
    )

}

export default Body